export enum EIdentifikaceOsoby {
    ELEKTRONICKY_PODPIS = 'EL',
    ELEKTRONICKY_PODPIS_UPLOADED = 'ELU',
    DOKLADY_TOTOZNOSTI = 'SC'
}
